import React, { useEffect } from "react";
import useDocumentTitle from "../hooks/useDocumentTitle";

/**
 * External redirect to the standalone Bloom Club site at heritagebloomclub.nz
 * (separate build, separate domain). Used by every public `/bloom-club*` route
 * on the main Heritage Dahlias site so anyone clicking through is bounced to
 * the dedicated Bloom Club experience.
 */
const BLOOM_CLUB_EXTERNAL = "https://heritagebloomclub.nz";

export default function BloomClubExternalRedirect() {
  useDocumentTitle("Heritage Bloom Club");
  useEffect(() => {
    // Hard navigation (not Link / Navigate) so the user lands at the standalone
    // Bloom Club site, not somewhere inside this SPA.
    window.location.replace(BLOOM_CLUB_EXTERNAL);
  }, []);
  return (
    <div
      data-testid="bloom-club-external-redirect"
      className="min-h-screen flex items-center justify-center px-6 bg-[#E8DCEB] text-[#3E2346]"
    >
      <div className="max-w-md text-center">
        <div className="text-[10px] tracking-[0.4em] uppercase opacity-60 mb-3">
          Heritage Bloom Club
        </div>
        <h1
          className="text-3xl font-normal mb-3"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
        >
          Taking you to the Bloom Club.
        </h1>
        <p className="text-sm opacity-75 mb-6">
          The Bloom Club now lives at its own home,{" "}
          <a
            href={BLOOM_CLUB_EXTERNAL}
            className="underline underline-offset-4 hover:text-[#7B4F82]"
            data-testid="bloom-club-external-link"
          >
            heritagebloomclub.nz
          </a>
          . If you're not redirected automatically, tap the link above.
        </p>
        <a
          href={BLOOM_CLUB_EXTERNAL}
          className="inline-flex items-center gap-2 px-6 h-11 bg-[#3E2346] text-[#FBE6D8] text-[11px] tracking-[0.3em] uppercase rounded-full hover:bg-[#5d3a64] transition-colors"
        >
          Visit the Bloom Club
        </a>
      </div>
    </div>
  );
}
